export default function (state) {
    let form = state;
    let data = {};

    switch (form.dateType) {
        case 1:
            if (form.dates[0]) data.PaymentDateFrom = {Serialized: form.dates[0]};
            if (form.dates[1]) data.PaymentDateTo = {Serialized: form.dates[1]};
            break;
        case 2:
            if (form.dates[0]) data.CreateDateFrom = {Serialized: form.dates[0]};
            if (form.dates[1]) data.CreateDateTo = {Serialized: form.dates[1]};
            break;
        case 3:
            if (form.dates[0]) data.PayDateFrom = {Serialized: form.dates[0]};
            if (form.dates[1]) data.PayDateTo = {Serialized: form.dates[1]};
            break;
    }
    if (form.CurrencyId.length) data.CurrencyId = form.CurrencyId;
    if (form.PayStates.length) data.PayStates = form.PayStates;

    if (form.AgreementCode) data.AgreementCode = encodeURIComponent(form.AgreementCode);
    if (form.PaymentOperationID) data.PaymentOperationID = form.PaymentOperationID;
    if (form.AccountNumber) data.AccountNumber = form.AccountNumber;
    if (form.LatePayments) data.LatePayments = form.LatePayments;
    if (form.OnlyAccepted) data.OnlyAccepted = form.OnlyAccepted;
    if (form.CashId) data.CashId = form.CashId;
    if (form.PaymentAccountId) data.PaymentAccountId = form.PaymentAccountId;
    if (form.RequirementSumFrom) data.RequirementSumFrom = form.RequirementSumFrom;
    if (form.RequirementSumTo) data.RequirementSumTo = form.RequirementSumTo;
    if (form.PaymentTypeId) data.PaymentTypeId = form.PaymentTypeId;

    if (form.RegularPaymentTypeId||form.RegularPaymentTypeId===0) data.RegularPaymentTypeId = form.RegularPaymentTypeId;
    if (form.CategoryId || form.CategoryId === 0) data.CategoryId = form.CategoryId;

    if (form.ContragentID) {
        data.ContragentID = form.ContragentID;
        data.ContragentType = form.ContragentType;
    }
    return data;
}